import React, { useEffect, useState } from 'react'
import { useLocation , useNavigate } from 'react-router-dom'
import '../../Assets/Css/ViewTransaction.scss'
import { FiArrowDownLeft, FiArrowUpLeft } from "react-icons/fi"
import Table from '../../Components/Table'
import { Link } from 'react-router-dom'
import { getSingleTransactions } from '../../Services/Transactions/action'
import { connect } from 'react-redux'
import moment from 'moment'
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";


const status = {
    "Draft" : "pending",
    "Sent" : "inprogress",
    "Partially Paid" : "partially-pay",
    "Paid" : "success"
}

const ViewTransaction = (props) => {
    const location = useLocation();
    const data = location?.state?.data;
    const navigate = useNavigate();
    const [viewData,setViewData]= useState({});
    const [spendList,setSpendList]=useState([]);

    const getTransactionData = async()=>{
        try {
            await props.getSingleTransactions(data.transactionId.value);
            setTheData();
        } catch (error) {
            console.log("Error",error);
        }
    }
    const setTheData = async()=>{
        if(props.transactionDetails){
            const myData = await props.transactionDetails;
            setViewData(myData);
        }
    }
    
    useEffect(()=>{
        if(data?.transactionId.value) {
            getTransactionData();
        }else{
            toast.error("Something went wrong");
            navigate("/transaction");
        }
    },[]);

    useEffect(()=>{
        props.amountList && setSpendList(props.amountList);
    },[props.amountList])

    useEffect(()=>{
        setTheData();
    },[props.transactionDetails])

    const header = [
        { field: 'Invoice No' },
        { field: "Date" },
        { field: "Clients" },
        { field: "Amount" },
        { field: "Status" },
    ];

    const headerSpends = [
        { field: 'Name' },
        { field: 'Amount' }
    ]

    const dataSpends = viewData?.transactionSpendMap?.map(items=>{
        return {
            Name: {
                value: items?.spendTransactionMap?.name,
                type: 'text'
            },
            Amount: {
                value: `₹${items?.amount || "-"} `,
                type: 'amount'
            }
        }
    })

    let footer = false;

    const headerShareholder =  [
        { field: 'Sr No' },
        { field: 'Share Holder' },
        { field: 'amount' },
        { field: 'mobile' },
        { field: 'role' }
    ];

        const shareHolder = new Set();

        viewData?.transactionShareHolderMap?.forEach(tranShalehoder=>{
            shareHolder.add(JSON.stringify({...tranShalehoder?.shareHolderTransactionMap, amount: parseFloat(tranShalehoder?.amount || 0)}));
        })
        const datashareholder = Array.from(shareHolder)?.map((items,index) => {
            items = JSON.parse(items);
            return {
                'Sr No': {
                    value: index+1,
                    type: 'text'
                },
                'Share Holder': {
                    value:  items?.name || "-",
                    value2:  items?.email || "-",
                    type: 'client'
                },
                'amount': {
                    value: items.amount,
                    type: 'text'
                },
                mobile: {
                    value: items?.mobile || "-",
                    type: 'text'
                },
                role: {
                    value: items?.role?.name || "-",
                    type: 'text'
                }
            }
           })
        
    const dataInvoice = viewData?.transactionInvoiceMap?.map(items=>{
        return {
                'Invoice No': {
                    value: items?.invoice_id || "-",
                    type: 'text',
                },
                Clients: {
                    value: items?.invoiceTransactionMap?.clientInvoices?.name || "-",
                    value2: items?.invoiceTransactionMap?.clientInvoices?.email || "-",
                    type: 'client'
                },
                Date: {
                    value: moment(items?.created_at).format('DD/MM/YYYY') ,
                    type: 'date'
                },
                Amount: {
                    value:  `₹${items?.amount}`,
                    type: 'amount'
                },
                Status: {
                    value: `${status[items?.invoiceTransactionMap?.status]}`,
                    type: 'status'
                }
            }
    }) || [];
    
    return (
            <div className='viewTransaction-main'>
                <div className="page-title">
                    <h4>View Transaction</h4>
                    <div className="edit-btn">
                        <button type="button" className="custom-btn">
                            <Link to='/transaction/edit' style={{ textDecoration: "inherit", color: "inherit" }} state={{data}}>
                                { props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Edit" }
                            </Link>
                        </button>
                    </div>
                </div>
                {
                    props.loading ? <div style={{
                        display:"flex",
                        justifyContent:"center"
                    }}>
                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                    </div> :  <div className="content-part">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="custom-card">
                                <div className="left-part">
                                    <div className="type">
                                        <div className="image">
                                            {(data?.Type?.type === 'credit') ? <div className="icon-credit">
                                                <FiArrowUpLeft />
                                            </div> : <div className="icon-debit">
                                                <FiArrowDownLeft />
                                            </div>}
                                        </div>

                                        <span>{data?.Type?.value}</span>
                                    </div>
                                    <div className="amount">
                                        <span>{data?.Amount?.value}</span>
                                    </div>
                                    <div className="description">
                                        <span>{data?.Description?.value}</span>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="right-part">
                                <div className="shareHolders">
                                    <h6 className='heading-title'>Share Holder Lists</h6>
                                    <Table header={headerShareholder} footer={footer} data={datashareholder || []} />
                                </div>
                                <div className="invoices">
                                    <h6 className='heading-title'>Invoice Lists</h6>
                                    <Table header={header} footer={footer} data={dataInvoice || []} />
                                </div>
                                {(data?.Type?.type === 'credit') ? null : <div className="spends">
                                    <h6 className='heading-title'>Spends Lists</h6>
                                    <Table header={headerSpends} footer={false} data={dataSpends || []} />
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                }
            </div>
    )
}

const mapStateToProps = (state)=>{
    return {
      loading : state.transactionReducers.loading,
      transactionDetails : state.transactionReducers.transactionDetails,
      amountList : state.spendReducer.amountList,
    }
  }
   const mapDispatchToProps = (dispatch)=>{
    return {
      getSingleTransactions : (id)=> {
        dispatch(getSingleTransactions(id))
      }
    }
  }

export default connect(mapStateToProps,mapDispatchToProps)(ViewTransaction);
